import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { jarvsiRMSOnboardingActions } from "stores/jarvisRMS/jarvisRMSOnboarding/jarvisRMSOnboardingAction";
import { jarvsiOnestockOnboardingActions } from "stores/jarvisOnestock/jarvisOnestockOnboarding/jarvisOnestockOnboardingAction";
import { onboardingActions } from "stores/onboarding/onboardingActions";
import { customerActions } from "stores/customer/customerActions";
import { jarvisPrimeOnboardingActions } from "stores/jarvisPrime/jarvisPrimeOnboarding/jarvisPrimeOnboardingActions";
import { sentimentTrackerOnboardingActions } from "stores/SentimentTracker/sentimentTrackerOnboarding/sentimentTrackerOnboardingAction";
import { PHCOnboardingActions } from "stores/PHC/PHCOnboarding/PHCOnboardingAction";

const mapStateToProps = (state) => {
  return {
    loginProfile: state.customer.loginProfile,
    source: state.common.source,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      // product's onboarding data update
      updatePortfolioOnboardingDataAction:
        onboardingActions.updateOnboardingData,
      updateRMSOnboardingDataAction:
        jarvsiRMSOnboardingActions.updateRMSOnboardingData,
      updateOnestockOnboardingDataAction:
        jarvsiOnestockOnboardingActions.updateOnestockOnboardingData,
      updatePrimeOnboardingDataAction:
        jarvisPrimeOnboardingActions.updatePrimeOnboardingData,
      updateSentimentTrackerOnboardingDataAction:
        sentimentTrackerOnboardingActions.updateSentimentTrackerOnboardingData,
      // fetch profile
      getProfileDataAction: customerActions.getProfile,
      updatePHCOnboardingDataAction:
        PHCOnboardingActions.updatePHCOnboardingData,
    },
    dispatch
  );

const DocumentSigningStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default DocumentSigningStore;
